let reflectionsData = [
	{
		id: 'crew-reflection',
		gameStep: 'crew-reflection',
		resultGameStep: 'crew-reflection-result',
		title: {
			en: 'Staff selection',
			de: 'Personalauswahl',
			pt: 'Seleção da equipa'
		},
		subtitle: {
			en: '1st DEBRIEF',
			de: '1. Nachbesprechung',
			pt: '1º Debrief'
		},
		resultSubtitle: {
			en: 'Results',
			de: 'Ergebnisse',
			pt: 'Resultados'
		},
		questions: [
			{
				id: 1,
				text: {
					en: `Personal issues may not necessarily be related to work but could still have an impact on the working environment.
						<br /><br />Have you experienced any situations where personal issues, your own or others, affected your ability to work effectively together as a team?`,
					de: `Persönliche Probleme hängen nicht unbedingt immer mit der Arbeit zusammen, können aber dennoch Auswirkungen auf das Arbeitsumfeld haben.
						<br /><br />Haben Sie bei Ihrer Arbeit bereits Situationen erlebt, in denen persönlichen Probleme, entweder Ihre eigenen oder die anderer, Ihre Fähigkeiten effektiv zusammen zu arbeiten erschwert haben?`,
					pt: `Problemas pessoais podem não estar necessariamente relacionados ao trabalho, mas ainda assim podem ter um impacto no ambiente de trabalho.
						<br /><br />Você já vivenciou alguma situação em que problemas pessoais, seus ou de outras pessoas, afetaram sua capacidade de trabalhar efetivamente em equipa?`
				},
				answerType: 'text',
				required: true
			},
			{
				id: 2,
				text: {
					en: `In the game you meet some people with different personalities and attitude.
						<br /><br />In your own work, have you experienced situations where certain personalities and attitudes had an negative effect on the working environment?`,
					de: `Im Spiel werden Sie auf verschiedene Persönlichkeiten und Eigenschaften treffen.
						<br /><br />Haben Sie bei Ihrer Arbeit Situationen erlebt, in denen bestimmte Persönlichkeiten und Einstellungen einen negativen Einfluss auf das Arbeitsumfeld hatten?`,
					pt: `No jogo, você encontra pessoas com personalidades e atitudes diferentes.<br /><br />
						No seu próprio trabalho, você já experienciou algumas situações em que certas personalidades e atitudes tiveram um efeito negativo no ambiente de trabalho?`
				},
				answerType: 'text',
				required: true
			},
			{
				id: 3,
				text: {
					en: `What can you do, as an individual and/or as a team, to mitigate the negative effects on the working environment caused by personal issues and different personalities and attitudes?`,
					de: `Was können Sie als Einzelperson und/oder im Team tun, um negative Auswirkungen von persönlichen Problemen auf das Arbeitsumfeld abzumildern?`,
					pt: `O que você pode fazer, individualmente ou em equipe, para mitigar os efeitos negativos no ambiente de trabalho causados ​​por problemas pessoais e diferentes personalidades e atitudes?`
				},
				answerType: 'text',
				required: true
			}
		]
	},
	{
		id: 'best-practices',
		gameStep: 'best-practices',
		resultGameStep: 'best-practices-result',
		title: {
			en: '2nd DEBRIEF',
			de: '2. Nachbesprechung',
			pt: '2º DEBRIEF'

		},
		subtitle: {
			en: 'Best practices',
			de: 'Empfohlene Vorgehensweisen',
			pt: 'Melhores práticas'
		},
		subtitle2: {
			en: 'Reflection',
			de: 'Reflexion',
			pt: 'Reflexão'
		},
		resultSubtitle: {
			en: 'Results',
			de: 'Ergebnisse',
			pt: 'Resultados'
		},
		question: {
			en: 'Discuss how you would implement the tools in a real-life scenario. Write your explanation here. Be practical and specific:',
			de: 'Besprechen Sie, wie Sie die Tools in einem echten Szenario implementieren würden. Notieren Sie hier Ihre Ideen. Seien Sie praktisch und konkret:',
			pt: `Discuta como você implementaria as ferramentas em um cenário real. Descreva aqui a sua explicação. Seja prático e específico:`
		},
		numberOfBestPracticesCardsToSelect: 2
	},
	{
		id: 'dd-reflection',
		gameStep: 'dd-reflection',
		resultGameStep: 'dd-reflection-result',
		title: {
			en: '3rd DEBRIEF',
			de: '3. Nachbesprechung',
			pt: `3º DEBRIEF`
		},
		subtitle: {
			en: 'Reflection',
			de: 'Reflektion',
			pt: 'Reflexão'
		},
		resultSubtitle: {
			en: 'Results',
			de: 'Ergebnisse',
			pt: 'Resultados'
		},
		showThreats: false,
		showDirtyDozens: true,
		numberOfDirtyDozensToSelect: 3,
		introText: {
			en: 'Make your own TOP 3 list by dragging the Dirty Dozen up and down.',
			de: 'Erstellen Sie Ihre eigene Top 3 Liste, indem Sie die Dirty Dozen nach oben oder nach unten ziehen.',
			pt: `Faça o seu TOP 3 dos "Dirty Dozen" arrastando para cima e para baixo.`
		},
		questions: [
			{
				id: 16,
				text: {
					en: 'Give examples on how and where these three Dirty Dozen affect you in your daily work.',
					de: 'Geben Sie Beispiele dafür, wie und wo sich diese drei Dirty Dozen auf Ihr tägliches Arbeitsleben auswirken.',
					pt: `Dê exemplos de como e onde esses três "Dirty Dozen" afetam você no seu trabalho diário.`
				},
				answerType: 'text',
				required: true
			},
			{
				id: 17,
				text: {
					en: 'What can we do to counteract the negative effect of the Dirty Dozen you have identified?',
					de: 'Was können wir tun, um den negativen Auswirkungen Ihrer gewählten Dirty Dozen entgegenzuwirken?',
					pt: `O que podemos fazer para neutralizar o efeito negativo dos "Dirty Dozen" que você identificou?`
				},
				answerType: 'text',
				required: true
			}
		]
	},
	{
		id: 'final-reflection',
		gameStep: 'final-reflection',
		resultGameStep: 'final-reflection-result',
		title: {
			en: 'Final',
			de: 'Finale',
			pt: `Final`
		},
		subtitle: {
			en: 'Reflection',
			de: 'Reflexion',
			pt: 'Reflexão'
		},
		showThreats: false,
		questions: [
			{
				id: 7,
				text: {
					en: `Select two of the topics on the list, which you believe is the most challenging for your company.
						<br /><br />Explain why you think they are challenging and then describe one or more concrete initiatives for improvement in those areas.`,
					de: `Wählen Sie zwei der Themen aus der Liste aus, die Ihrer Meinung nach die größten Herausforderungen für Ihr Unternehmen darstellen.
						<br /><br /> Erklären Sie, weshalb Sie glauben, dass diese eine Herausforderung darstellen und beschreiben Sie dann eine oder mehrere konkrete Initiativen zur Verbesserung.`,
					pt: `Selecione dois dos tópicos da lista que você considera mais desafiadores para sua empresa.
						<br /><br />Explique por que você os considera desafiadores e, em seguida, descreva uma ou mais iniciativas concretas para melhoria nessas áreas.`
				},
				answerType: 'text',
				rows: 10,
				required: true
			},	
		],
		numberOfTopicsToSelect: 2,
		topics: [
			{
				id: 'handover-procedures',
				title: {
					en: 'Handover procedures',
					de: 'Übergabeverfahren',
					pt: 'Manual de procedimentos'
				}
			},
			{
				id: 'tool-control',
				title: {
					en: 'Tool control',
					de: 'Werkzeugkontrolle',
					pt: 'Control de ferramentas'
				}
			},
			{
				id: 'environmental-effects',
				title: {
					en: 'Environmental effects',
					de: 'Umwelteinflüsse',
					pt: 'Efeitos ambientais'
				}
			},
			{
				id: 'human-p-and-l',
				title: {
					en: 'Human performance and limitations',
					de: 'Menschliche Leistungsfähigkeit und Grenzen',
					pt: 'Performance Humana e suas limitações'
				}
			},
			{
				id: 'operational-pressure',
				title: {
					en: 'Operational pressure',
					de: 'Betriebsbedingter Druck',
					pt: 'Pressão operacional'
				}
			},
			{
				id: 'safety-culture',
				title: {
					en: 'Safety culture',
					de: 'Sicherheitskultur',
					pt: 'Cultura de segurança'
				}
			},
			{
				id: 'use-of-documentation',
				title: {
					en: 'Use of documentation',
					de: 'Verwendung von Dokumentation',
					pt: 'Uso de documentação'
				}
			}
		]
	},
];

export {reflectionsData};